import React from 'react';

import Icon from 'components/Icon/Icon';

interface IProps {
  facebook?: string;
  instagram?: string;
}

const isLinkDisabled = (link: string | undefined) => (link === '' || link === '/' ? false : true);

export const SocialMedia = ({facebook, instagram}: IProps) => {
  return (
    <div className="overview-header__social-media">
      <a
        title="facebook"
        className="overview-header__social-media-link"
        style={{pointerEvents: isLinkDisabled(facebook) ? 'auto' : 'none'}}
        href={`https://${facebook}`}
        rel="noreferrer"
        target="_blank"
      >
        <Icon icon="facebook" />
      </a>
      <a
        title="instagram"
        style={{pointerEvents: isLinkDisabled(instagram) ? 'auto' : 'none'}}
        className="overview-header__social-media-link"
        href={`https://${instagram}`}
        rel="noreferrer"
        target="_blank"
      >
        <Icon icon="instagram-link" />
      </a>
    </div>
  );
};
